var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/navigation/BaseMenu.tsx",
  _this = this;
import React, { useContext } from 'react';
import HeaderContext from '../../HeaderContext';
import { Home } from './Home';
import { Dashboard } from './Dashboard';
import { MySurveys } from './MySurveys';
import { Pricing } from './Pricing';
import { TeamMenu } from './TeamMenu';
import { DataStudio } from './DataStudio';
import { StaticContext } from '../../../../StaticContext';
var BaseMenu = function BaseMenu(_ref) {
  var _experiment$lihpHeade, _headerContext$user, _HEADER_EXP$isEAPUser;
  var experiment = _ref.experiment;
  var headerContext = useContext(HeaderContext);
  // Global Header experiment
  // https://momentiveai.atlassian.net/browse/HOME-737
  var lihpTreatment = experiment === null || experiment === void 0 ? void 0 : (_experiment$lihpHeade = experiment.lihpHeader) === null || _experiment$lihpHeade === void 0 ? void 0 : _experiment$lihpHeade.treatment;
  var _ref2 = (_headerContext$user = headerContext === null || headerContext === void 0 ? void 0 : headerContext.user) !== null && _headerContext$user !== void 0 ? _headerContext$user : {},
    homePageEnabled = _ref2.homePageEnabled,
    hasLIHPFeature = _ref2.hasLIHPFeature,
    hasSeenLIHPWelcomeModal = _ref2.hasSeenLIHPWelcomeModal;
  var hasLIHPTreatment = ['has_lihp', 'lihp_paid_individuals_treatment', 'lihp_teams_treatment', 'lihp_sme_treatment'].includes(lihpTreatment);

  // Global Header experiment for EAP Users
  // https://surveymonkey.atlassian.net/browse/AN-2776
  // https://admin.surveymonkey.com/experiments/surveymonkey/2439
  var _useContext = useContext(StaticContext),
    _useContext$HEADER_EX = _useContext.HEADER_EXP,
    HEADER_EXP = _useContext$HEADER_EX === void 0 ? {} : _useContext$HEADER_EX;
  var EAPExperimentTreatment = HEADER_EXP === null || HEADER_EXP === void 0 ? void 0 : (_HEADER_EXP$isEAPUser = HEADER_EXP.isEAPUser) === null || _HEADER_EXP$isEAPUser === void 0 ? void 0 : _HEADER_EXP$isEAPUser.treatment;
  var hasEAPEntryPointExperiment = EAPExperimentTreatment === 'analyze_workspaces_button_treatment';
  return /*#__PURE__*/React.createElement(React.Fragment, null, homePageEnabled !== false && (hasLIHPFeature || hasSeenLIHPWelcomeModal || hasLIHPTreatment) ? /*#__PURE__*/React.createElement(Home, {
    key: "menu-home",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 9
    }
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dashboard, {
    key: "menu-dashboard",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(MySurveys, {
    key: "menu-surveys",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(TeamMenu, {
    key: "menu-team",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Pricing, {
    key: "menu-pricing",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 7
    }
  }), hasEAPEntryPointExperiment && /*#__PURE__*/React.createElement(DataStudio, {
    key: "menu-data-studio",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 38
    }
  }));
};
export default BaseMenu;
//# sourceMappingURL=BaseMenu.js.map